import { encodeUrlArray } from '../../../hooks/useUrlArrayParam';
import type { OverviewAssignee } from '../../../services/dmMonitoringOverview';
import { ASSIGNEE_FILTER_ME, ASSIGNEE_FILTER_UNASSIGNED } from '../../../utils/assigneeFilter';
import { MESSAGE_LIST_PARAM, MESSAGES_LIST_PATH } from '../messages/messageListParams';
import { LIST_PARAM, NOTIFICATIONS_LIST_PATH } from '../notifications/notificationListParams';

export { MESSAGES_LIST_PATH, NOTIFICATIONS_LIST_PATH };

function withParam(path: string, key: string, values: string[]): string {
    const search = new URLSearchParams({ [key]: encodeUrlArray(values) });
    return `${path}?${search.toString()}`;
}

// The list filters take the assignee dropdown's values: emails, or "Unassigned" / "Me".
function assigneeFilterValue(
    assignee: Pick<OverviewAssignee, 'userId' | 'email'>,
    currentUserEmail: string | undefined
): string | null {
    if (assignee.userId === null) return ASSIGNEE_FILTER_UNASSIGNED;
    if (assignee.email && assignee.email === currentUserEmail) return ASSIGNEE_FILTER_ME;
    return assignee.email;
}

// Messages-only assignees go to Messages, where their work is; their Notifications list is empty.
export function assigneeListPath(
    assignee: OverviewAssignee,
    currentUserEmail: string | undefined
): string {
    const toMessages = assignee.notifications === 0 && assignee.messages > 0;
    const path = toMessages ? MESSAGES_LIST_PATH : NOTIFICATIONS_LIST_PATH;
    const key = toMessages ? MESSAGE_LIST_PARAM.assignees : LIST_PARAM.assignees;
    const value = assigneeFilterValue(assignee, currentUserEmail);
    return value ? withParam(path, key, [value]) : path;
}
